__turbopack_context__.v({
  "root": "LabelledDate-module__9CxuFW__root" + " " + __turbopack_context__.i(60951)["labelledStyles"],
});
